import { render, staticRenderFns } from "./notification-DocumentUploaded.vue?vue&type=template&id=79e94b4c&scoped=true"
import script from "./notification-DocumentUploaded.vue?vue&type=script&lang=js"
export * from "./notification-DocumentUploaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e94b4c",
  null
  
)

export default component.exports